if (!customElements.get('image-compare-slider')) {
  customElements.define(
    'image-compare-slider',
    class ImageCompareSlider extends HTMLElement {
      constructor() {
        super();
        this.range = this.querySelector('.image-spotlight__compare-range');
        this.autoplaySweepDuration = 750;
        this.autoplayEdgeDelay = 1500;
        this.direction = 1;
        this.rafId = null;
        this.hasInteracted = false;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.range) return;

        this.min = Number(this.range.min);
        this.max = Number(this.range.max);
        this.updatePosition();

        this.range.addEventListener('input', this.updatePosition.bind(this));
        this.range.addEventListener('pointerdown', this.stopAutoplay.bind(this));
        this.range.addEventListener('keydown', this.stopAutoplay.bind(this));
      }

      connectedCallback() {
        if (!this.range || this.prefersReducedMotion) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.startAutoplay();
            } else {
              this.pauseAutoplay();
            }
          });
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.pauseAutoplay();
        if (this.observer) this.observer.disconnect();
      }

      updatePosition() {
        this.style.setProperty('--image-compare-position', `${this.range.value}%`);
      }

      startAutoplay() {
        if (this.rafId || this.prefersReducedMotion || this.hasInteracted) return;

        const sweepRate = (this.max - this.min) / this.autoplaySweepDuration;
        let lastTimestamp = null;
        let holdUntil = 0;

        const step = (timestamp) => {
          if (lastTimestamp === null) lastTimestamp = timestamp;
          const elapsed = timestamp - lastTimestamp;
          lastTimestamp = timestamp;

          if (timestamp < holdUntil) {
            this.rafId = requestAnimationFrame(step);
            return;
          }

          let value = Number(this.range.value) + this.direction * sweepRate * elapsed;

          if (value >= this.max) {
            value = this.max;
            this.direction = -1;
            holdUntil = timestamp + this.autoplayEdgeDelay;
          } else if (value <= this.min) {
            value = this.min;
            this.direction = 1;
            holdUntil = timestamp + this.autoplayEdgeDelay;
          }

          this.range.value = value;
          this.updatePosition();
          this.rafId = requestAnimationFrame(step);
        };

        this.rafId = requestAnimationFrame(step);
      }

      pauseAutoplay() {
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
      }

      stopAutoplay() {
        this.hasInteracted = true;
        this.pauseAutoplay();
      }
    }
  );
}
